import { render, staticRenderFns } from "./selectData.vue?vue&type=template&id=06ca82a9&scoped=true"
import script from "./selectData.vue?vue&type=script&lang=js"
export * from "./selectData.vue?vue&type=script&lang=js"
import style0 from "./selectData.vue?vue&type=style&index=0&id=06ca82a9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ca82a9",
  null
  
)

export default component.exports